function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import qs from 'qs';
import { env } from "./fetch";
import { getAuthToken } from "../const";
export var bizDomain = ['micun.com', 'micun.cn'];
export function isBizUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!url) {
    return false;
  }
  try {
    var urlObj = new URL(url);
    var host = urlObj.host;
    var result = bizDomain.some(function (domain) {
      return host.includes(domain);
    });
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
}
export var isProd = process.env.REACT_APP_ENV === 'production';
export var isProdEnv = isProd && window.location.host.includes('micun.com');
export function getBaseOrigin() {
  var subdomain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'api';
  var suffix = isProd ? 'micun.com' : 'micun.cn';
  var fullSubdomain = window.location.host.split('.').slice(0, -2);
  var envDomain = '';
  if (!isProd) {
    envDomain = env || (fullSubdomain.includes('beta') ? 'beta' : 'dev');
  }
  var host = [subdomain, envDomain, suffix].filter(function (s) {
    return !!s;
  }).join('.');
  // const protocol = isProd ? 'https:' : 'http:'
  var protocol = window.location.protocol;
  return "".concat(protocol, "//").concat(host);
}
export var encodeUrlParam = function encodeUrlParam(data) {
  return qs.stringify(data, {
    allowDots: true,
    arrayFormat: 'indices',
    filter: function filter(_prefix, value) {
      if (value == null || value === '' || Array.isArray(value) && value.length === 0) {
        return;
      }
      if (Array.isArray(value)) {
        return value.filter(function (v) {
          return v !== null || v !== '';
        });
      }
      return value;
    }
  });
};
export var downloadFile = function downloadFile(url) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isAnchorDownload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var baseUrl = getBaseOrigin();
  var hasQuery = url.indexOf('?') !== -1;
  if (!/^http/.test(url)) {
    if (url.startsWith('/')) {
      url = url.slice(1);
    }
    if (baseUrl.endsWith('/')) {
      baseUrl = baseUrl.slice(0, -1);
    }
  }
  var saToken = getAuthToken();
  var queryStr = qs.stringify(_objectSpread(_objectSpread({}, query), {}, {
    satoken: saToken
  }), {
    allowDots: true,
    arrayFormat: 'repeat'
  });
  var downloadUrl = "".concat(baseUrl, "/").concat(url).concat(hasQuery ? '&' : '?').concat(queryStr);
  if (isAnchorDownload) {
    var a = document.createElement('a');
    a.href = downloadUrl;
    a.target = '_blank';
    a.download = '';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    var win = window.open('', '_blank');
    if (win) {
      win.location.href = downloadUrl;
    }
  }
};